import { HTMLAttributes, FC } from "react";
import clsx from "classnames";
import { useStyles } from "./CircularProgress.style";
import { useTranslation } from "react-i18next";

interface ICircularProgressProps {
  size?: number;
  enableAnimation?: boolean;
  borderLight?: boolean;
}

export const CircularProgress: FC<
  ICircularProgressProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    className,
    style,
    size,
    enableAnimation,
    borderLight,
    ...othersProps
  } = props;
  const sizeApply = size || 30;

  const styleInternal = {
    width: sizeApply,
    height: sizeApply,
    border: `${sizeApply / 10}px solid transparent`,
    borderTop: `${sizeApply / 10}px solid #fff`,
  };

  return (
    <div
      role="status"
      aria-label={t("LoadingScreen_Loading")}
      {...othersProps}
      className={clsx(
        classes.root,
        enableAnimation && classes.showAnimation,
        className,
      )}
      style={{ ...styleInternal, ...style }}
    />
  );
};
